import { BadgeCheck, Radio } from "lucide-react";

export const Logo = ({ className = "" }) => (
  <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
    <div className="relative h-8 w-8 rounded-xl bg-[hsl(var(--gold))] grid place-items-center text-[#0B0F17] font-extrabold">
      K
      <span className="absolute -right-1 -top-1 h-2.5 w-2.5 rounded-full bg-red-500 live-dot" />
    </div>
    <span className="font-extrabold tracking-tight text-lg">
      Koiné<span className="text-[hsl(var(--gold))]"> Live</span>
    </span>
  </div>
);

export const VerifiedBadge = ({ size = 14, className = "" }) => (
  <BadgeCheck size={size} className={`text-emerald-400 shrink-0 ${className}`} data-testid="institutional-seal-badge" aria-label="Instituição verificada" />
);

export const LiveBadge = ({ className = "" }) => (
  <span className={`inline-flex items-center gap-1.5 rounded-full bg-red-600 px-2.5 py-1 text-[10px] font-black tracking-wider text-white shadow-lg shadow-red-500/30 ${className}`} data-testid="live-badge">
    <Radio size={11} className="live-dot" />
    AO VIVO
  </span>
);

export const initials = (name = "") =>
  name
    .split(" ")
    .filter((w) => w.length > 2 || /^[A-Z]/.test(w))
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

export const InstitutionMark = ({ name, logo, color, size = 28 }) =>
  logo ? (
    <img src={logo} alt={name} style={{ width: size, height: size }} className="rounded-lg object-cover ring-1 ring-white/20 shrink-0" />
  ) : (
    <div style={{ width: size, height: size, background: color || "#6366F1" }} className="rounded-lg grid place-items-center text-[10px] font-extrabold text-white ring-1 ring-white/20 shrink-0">
      {initials(name)}
    </div>
  );

export const Avatar = ({ name, src, size = 40, className = "" }) =>
  src ? (
    <img src={src} alt={name} style={{ width: size, height: size }} className={`rounded-full object-cover ${className}`} />
  ) : (
    <div style={{ width: size, height: size }} className={`rounded-full grid place-items-center bg-secondary text-xs font-bold ${className}`}>
      {initials(name) || "?"}
    </div>
  );
